import { Currency, Money, SearchFilter } from '@rygen/rygen-ui/model';

export class MoneySearchFilter extends SearchFilter<Money> {
  min?: number;
  max?: number;
  currency?: Currency;

  constructor(opts?: Partial<MoneySearchFilter>) {
    super(opts);

    if (opts?.min != null) {
      this.min = opts.min;
    }
    if (opts?.max != null) {
      this.max = opts.max;
    }
    if (opts?.currency != null) {
      this.currency = opts.currency;
    }

    this.pageSize = opts?.pageSize ?? 10;
    this.sortField = opts?.sortField ?? 'amount';
    this.sortDirection = opts?.sortDirection ?? 'ASC';
  }
}
